import * as React from "react"
import {uniqueId} from "./sbhtml"

export type Props = {
	label?: string
	name?: string
	value?: string
	checked?: boolean
	disabled?: boolean
	onChange?: (nowChecked: boolean) => void
}

const unlabelledButton = (props: Props, id: string) => {
	const onChange = props.onChange

	return <input
		type="radio"
		name={props.name}
		value={props.value}
		checked={props.checked}
		disabled={props.disabled}
		onChange={onChange ? e => onChange((e.target as HTMLInputElement).checked) : undefined}
		className="sbRadioButton"
		id={id}
	/>
}

export const Radio = (props: Props) => {
	const id = uniqueId()
	const button = unlabelledButton(props,id)

	return props.label === undefined
		? button
		: <label htmlFor={id}>{button}{props.label}</label>
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/radio.tsx